import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import AdminContent from "./admin/AdminContent";
import AdminCollections from "./admin/AdminCollections";
import AdminInbox from "./admin/AdminInbox";
import AdminComments from "./admin/AdminComments";
import api from "../lib/api";

const TABS = [
  { key: "conteudo", label: "Conteúdo do site" },
  { key: "reflexoes", label: "Reflexões" },
  { key: "produtos", label: "Produtos" },
  { key: "mentoria", label: "Mentoria" },
  { key: "mural", label: "Mural" },
  { key: "leads", label: "Leads" },
  { key: "mensagens", label: "Mensagens" },
];

export default function Admin() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("conteudo");
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, [tab]);

  return (
    <div className="min-h-screen bg-[#050505] font-sans text-zinc-200" data-testid="admin-page">
      <div className="grain-overlay" aria-hidden="true" />
      <header className="border-b border-gold/15 bg-black/60 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-12">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/50 font-serif text-xs text-gold">REF</span>
            <div>
              <p className="font-serif text-sm tracking-[0.25em] text-zinc-100">PAINEL REFLLEXIVE</p>
              <p className="text-[0.65rem] uppercase tracking-[0.2em] text-zinc-500">{user?.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <a href="/" className="text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-gold" data-testid="admin-view-site-link">Ver site</a>
            <button onClick={logout} className="text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-gold" data-testid="admin-logout-button">Sair</button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-7xl px-6 py-10 lg:px-12">
        {stats && (
          <div className="mb-10 grid grid-cols-2 gap-px bg-gold/10 sm:grid-cols-5" data-testid="admin-stats">
            {[["Membros", stats.users], ["Leads", stats.leads], ["Mensagens", stats.messages], ["Reflexões", stats.posts], ["Produtos", stats.products]].map(([label, value]) => (
              <div key={label} className="bg-[#0a0a0a] p-6">
                <p className="font-serif text-3xl text-gold">{value}</p>
                <p className="mt-2 text-[0.65rem] uppercase tracking-[0.2em] text-zinc-500">{label}</p>
              </div>
            ))}
          </div>
        )}

        <nav className="flex flex-wrap gap-2 border-b border-gold/15 pb-6" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`border px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] transition-colors ${
                tab === t.key ? "border-gold bg-gold text-black" : "border-gold/20 text-zinc-400 hover:border-gold/50 hover:text-gold"
              }`}
              data-testid={`admin-tab-${t.key}`}
            >
              {t.label}
            </button>
          ))}
        </nav>

        <div className="py-10">
          {tab === "conteudo" && <AdminContent />}
          {tab === "reflexoes" && <AdminCollections kind="posts" />}
          {tab === "produtos" && <AdminCollections kind="products" />}
          {tab === "mentoria" && <AdminCollections kind="mentoria" />}
          {tab === "mural" && <AdminComments />}
          {tab === "leads" && <AdminInbox kind="leads" />}
          {tab === "mensagens" && <AdminInbox kind="messages" />}
        </div>
      </div>
    </div>
  );
}
